import { getCasing } from './casing.js';
import { removeDuplicates } from './common.js';
import { getFilters, getSortKeys } from './filtering.js';
import { getLists } from './lists.js';
import { getDefaults } from './params.js';
import { getParents, getRelations } from './relatives.js';
export class BaseMenuEntityConfiguration {
    config;
    constructor(config) {
        this.config = config;
    }
}
class MenuEntityConfiguration {
    _configuration;
    allConfigurations;
    constructor(baseConfiguration, allConfigurations) {
        this._configuration = baseConfiguration.config;
        const defaultValue = {};
        this.allConfigurations = Object.entries(allConfigurations).reduce((acc, [collection, baseConfig]) => ({
            ...acc,
            [collection]: baseConfig.config,
        }), defaultValue);
    }
    get defaults() {
        return getDefaults(this._configuration);
    }
    get casing() {
        return getCasing(this._configuration);
    }
    get filters() {
        return getFilters(this._configuration);
    }
    get sortKeys() {
        return getSortKeys(this._configuration);
    }
    get parents() {
        return getParents(this._configuration, this.allConfigurations);
    }
    get relations() {
        return getRelations(this._configuration, this.allConfigurations);
    }
    get lists() {
        return getLists(this._configuration.lists, this.allConfigurations);
    }
    get brandSyncedAttributes() {
        const { sellable, hasImage, hasDescription, hasHours, hasVariations, options, unlinkedOptions, consumable, } = this._configuration;
        const defaultBrandSyncedAttributes = [
            'name',
            'available',
            'availableAt',
            'displayName',
        ];
        if (sellable)
            defaultBrandSyncedAttributes.push('amount', 'taxRate', 'taxable');
        if (hasImage)
            defaultBrandSyncedAttributes.push('image');
        if (hasDescription)
            defaultBrandSyncedAttributes.push('description');
        if (hasHours)
            defaultBrandSyncedAttributes.push('hours');
        if (hasVariations)
            defaultBrandSyncedAttributes.push('variationGroups');
        if (consumable)
            defaultBrandSyncedAttributes.push('allergens', 'alcohol', 'glutenFree', 'vegetarian');
        return removeDuplicates([
            ...defaultBrandSyncedAttributes,
            ...Object.keys(options),
        ]).filter((property) => !unlinkedOptions.includes(property));
    }
    get configuration() {
        const { hasDescription, hasHours, hasImage, hasVariations, hasPos, hasPresentation, sellable, consumable, options, unlinkedOptions, version, name, } = this._configuration;
        const { defaults, casing, filters, brandSyncedAttributes, lists, sortKeys, parents, relations, } = this;
        return {
            hasDescription,
            hasHours,
            hasImage,
            hasVariations,
            hasPos,
            hasPresentation,
            sellable,
            consumable,
            options,
            unlinkedOptions,
            sortKeys,
            version,
            casing,
            defaults,
            filters,
            parents,
            relations,
            lists,
            name,
            brandSyncedAttributes,
        };
    }
}
export default MenuEntityConfiguration;
//# sourceMappingURL=index.js.map